import base from './base'
import survey from './survey'
import malls from './malls'
import company from './company'
import businessCard from './businessCard'
import uplaod from './upload'
import dynamic from './dynamic'
import customer from './customer'
import website from './website'
import appointment from './appointment'
import house from './house'
import sweepPayment from './sweepPayment'
import system from './system'
import groupPush from './groupPush'
import poster from './poster'
import article from './article'
import activity from './activity'
import diy from './diy'
import baidu from './baidu'
import drainage from './drainage'
import bytedance from './bytedance'
import color from './color'
import linepay from './linepay'
import casepic from './casepic'
import account from './account'
import integral from './integral'
import lottery from './lottery'
import customerArchives from './customerArchives'
export default {
  ...survey,
  ...malls,
  ...company,
  ...businessCard,
  ...uplaod,
  ...dynamic,
  ...customer,
  ...website,
  ...appointment,
  ...house,
  ...sweepPayment,
  ...system,
  ...groupPush,
  ...poster,
  ...article,
  ...activity,
  ...base,
  ...diy,
  ...baidu,
  ...drainage,
  ...bytedance,
  ...color,
  ...linepay,
  ...casepic,
  ...account,
  ...integral,
  ...lottery,
  ...customerArchives
}



// WEBPACK FOOTER //
// ./src/api/modules/index.js